import { useMemo, useState } from 'react';

/**
 * Paginación client-side sobre un array ya filtrado. Repetida idéntica
 * (page/pageSize/totalPages/pageStart/pageEnd/slice) en Areas, Pisos,
 * Tareas, TipoAreas y QRLinks. No decide cuándo resetear a la página 0
 * al cambiar filtros — cada página conserva su propio useEffect para eso,
 * ya que sus dependencias (qué filtros disparan el reset) son distintas
 * página a página.
 */
export function usePagination<T>(items: T[], pageSize = 10) {
  const [page, setPage] = useState(0);

  const totalItems = items.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const pageStart = page * pageSize;
  const pageEnd = Math.min(pageStart + pageSize, totalItems);
  const pageItems = useMemo(() => items.slice(pageStart, pageEnd), [items, pageStart, pageEnd]);

  const goPrevPage = () => setPage((p) => Math.max(0, p - 1));
  const goNextPage = () => setPage((p) => Math.min(totalPages - 1, p + 1));

  return { page, setPage, pageSize, totalItems, totalPages, pageStart, pageEnd, pageItems, goPrevPage, goNextPage };
}
